import React from 'react';

export default function Password() {
  return (
    <svg
      width='42'
      height='41'
      viewBox='0 0 42 41'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_di_931_5110)'>
        <g clipPath='url(#clip0_931_5110)'>
          <rect
            x='1'
            width='40'
            height='40'
            rx='12'
            fill='url(#paint0_linear_931_5110)'
          />
          <g filter='url(#filter1_dd_931_5110)'>
            <path
              d='M18 24H24V26H18V24ZM22.793 14.793L21 16.586L19.207 14.793L17.793 16.207L19.586 18L17.793 19.793L19.207 21.207L21 19.414L22.793 21.207L24.207 19.793L22.414 18L24.207 16.207L22.793 14.793ZM26 26H32V24H26V26ZM32.207 16.207L30.793 14.793L29 16.586L27.207 14.793L25.793 16.207L27.586 18L25.793 19.793L27.207 21.207L29 19.414L30.793 21.207L32.207 19.793L30.414 18L32.207 16.207ZM9.99997 26H16V24H9.99997V26ZM14.793 14.793L13 16.586L11.207 14.793L9.79297 16.207L11.586 18L9.79297 19.793L11.207 21.207L13 19.414L14.793 21.207L16.207 19.793L14.414 18L16.207 16.207L14.793 14.793Z'
              fill='url(#paint1_linear_931_5110)'
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id='filter0_di_931_5110'
          x='0.5'
          y='0'
          width='41'
          height='41'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_931_5110'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_931_5110'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect2_innerShadow_931_5110'
          />
        </filter>
        <filter
          id='filter1_dd_931_5110'
          x='-21'
          y='-18.1015'
          width='84'
          height='84'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='10' />
          <feGaussianBlur stdDeviation='10' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_931_5110'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='3.89851' />
          <feGaussianBlur stdDeviation='15' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_931_5110'
            result='effect2_dropShadow_931_5110'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_931_5110'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_931_5110'
          x1='21'
          y1='0'
          x2='21'
          y2='40'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#29282C' />
          <stop offset='1' stopColor='#100F11' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_931_5110'
          x1='9.61979'
          y1='12.4903'
          x2='14.9595'
          y2='28.1438'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0.65' />
        </linearGradient>
        <clipPath id='clip0_931_5110'>
          <rect x='1' width='40' height='40' rx='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}